import { ChangeDetectorRef, Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import {IvyCarouselModule} from 'angular-responsive-carousel';
import { Producto } from 'src/app/models/generic/Producto';
import { AutenticacionService } from 'src/app/services/autenticacion.service';
import { ConfiguracionInicialService } from 'src/app/services/configuracioninicial.service';
import { UtilitariosService } from 'src/app/services/utilitarios.service';
import { MenuService } from '../../services/menu.service';
import { ProductosService } from '../../services/productos.service';
import { ProductosResumen } from '../../models/generic/ProductosResumen';
import { TamanoAppService } from 'src/app/services/tamanoapp.service';
import { Menu } from 'src/app/models/generic/Menu';
import { SeleccionAliadoCanalComponent } from '../seleccionaliadocanal/seleccionaliadocanal.component';
import { SeleccionAliadoCanalMenu } from 'src/app/models/generic/SeleccionAliadoCanalMenu';

@Component({
  selector: 'globalservicios',
  templateUrl: './globalservicios.component.html',
  styleUrls: ['./globalservicios.component.scss']
})
export class GlobalserviciosComponent implements OnInit{
  parametrosComponente: string = '';
  nombreComponenteRegistro: string = 'RegistrarAfiliadoComponent';
  @ViewChild('appseleccionaliadocanal', {static: false}) _appseleccionaliadocanal: SeleccionAliadoCanalComponent;

  constructor(public router: Router,
    public fb: FormBuilder,
    public cd: ChangeDetectorRef,
    public utilitariosService: UtilitariosService,
    public configuracionInicialService: ConfiguracionInicialService,
    public autenticacionService: AutenticacionService,
    public menuService: MenuService,
    public productosService: ProductosService,
    public tamanoAppService: TamanoAppService) {}

  ngOnInit() {
  }

  NuevoClienteServicio(itemProducto: Producto) {
    this.parametrosComponente = JSON.stringify(itemProducto);
    this.ValidarItemMenu();
  }

  ValidarItemMenu() {
    let itemMenu = this.menuService.ListaMenu.filter(x => x.componente === this.nombreComponenteRegistro);
    if (itemMenu.length > 0) {
      this.VerificarAliadoCanalRequerido(itemMenu[0]);
    } else {
      this.menuService.CambiarComponenteActivo(this.nombreComponenteRegistro, this.parametrosComponente);
    }
  }

  VerificarAliadoCanalRequerido(itemMenuHijo: Menu) {
    if (itemMenuHijo.requiereAliado && this.utilitariosService.VerificarContieneDatosNumerico(this.autenticacionService.AplicacionSeleccionado) === false) {
      this._appseleccionaliadocanal.MostrarMensajeConfirmacion(itemMenuHijo);
    } else if (itemMenuHijo.requiereCanal && this.utilitariosService.VerificarContieneDatosNumerico(this.autenticacionService.CanalSeleccionado) === false) {
      this._appseleccionaliadocanal.MostrarMensajeConfirmacion(itemMenuHijo);
    } else {
      this.menuService.CambiarComponenteActivo(itemMenuHijo.componente, this.parametrosComponente);
    }
  }

  SeleccionoAliadoCanal(registroUsuario: SeleccionAliadoCanalMenu) {
    if (registroUsuario.confirmoUsuario) {
      this.menuService.CambiarComponenteActivo(this.nombreComponenteRegistro, this.parametrosComponente);
    }
  }

}
